import React, { Suspense } from "react";
import classes from "./SDButton.module.css";

import Button from "@material-ui/core/Button";

const SDButton = (props) => {
  // const IconURI = React.lazy(() =>
  //   import("@material-ui/icons/" + props.imageURI)
  // );
  // const path = (
  //   <Suspense fallback={<p>Image not found</p>}>
  //     <IconURI />
  //   </Suspense>
  // );
  return (
    <div className={classes.SDButton}>
      {/* <Button startIcon={path} onClick={props.onClick}> */}
      <Button onClick={props.onClick}>{props.children}</Button>
    </div>
  );
};

export default SDButton;
